var React = require('react');

function Other (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"2","cy":"2","r":"2","fill":"#34363E","key":0}),React.createElement("circle",{"cx":"9","cy":"2","r":"2","fill":"#34363E","key":1}),React.createElement("circle",{"cx":"16","cy":"2","r":"2","fill":"#34363E","key":2})]);
}

Other.defaultProps = {"width":"18","height":"4","viewBox":"0 0 18 4","fill":"none"};

module.exports = Other;

Other.default = Other;
